<template>
  <v-layout v-if="!isRendering" wrap row>
    <v-flex xs12>
      <v-btn class="ml-4n" flat @click="onClickBack()">
        <i class="fas fa-chevron-left mr-1"></i>
        {{ $t('Back') }}
      </v-btn>
    </v-flex>
    <v-flex xs12 style="padding: 16px 64px">
      <h3 class="primary--text mb-2">
        {{ payload.id ? $t('step_message.edit') : $t('step_message.create') }}
      </h3>
    </v-flex>
    <v-flex xs12 style="padding: 16px 64px">
      <label :class="[isValidation && !audience.name && 'error--text']"
        >{{ $t('step_message.audience_name') }} <span class="error--text">*</span>
      </label>
      <v-text-field
        v-model="audience.name"
        class="my-2"
        outline
        hide-details
        single-line
      ></v-text-field>
      <span
        v-if="isValidation && !audience.name"
        id="stepmessage_audience_name"
        class="error--text"
      >
        {{ $t('step_message.validate_name') }}
      </span>
    </v-flex>
    <v-flex xs12 style="padding: 16px 64px">
      <div class="timeline">
        <div class="timeline-item" style="--content: '1'">
          <h4 class="timeline-item--header">{{ $t('step_message.create_starting_audience') }}</h4>
          <div class="timeline-content transparent">
            <v-container class="grid-list-md pa-0">
              <v-layout class="w-100" row wrap>
                <v-flex xs12>
                  <v-radio-group
                    v-model="audience.init_type"
                    hide-details
                    @change="onChangeInitType"
                  >
                    <v-layout class="w-100" row wrap>
                      <v-flex xs12 sm6>
                        <v-radio
                          class="mb-4"
                          :label="$t('step_message.none')"
                          :value="null"
                          :disabled="Boolean(payload.id)"
                          color="primary"
                        ></v-radio>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-radio
                          class="mb-4"
                          :label="$t('step_message.create_from_customer_orders')"
                          value="order"
                          :disabled="Boolean(payload.id)"
                          color="primary"
                        ></v-radio>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-radio
                          class="mb-4"
                          :label="$t('step_message.create_from_tags')"
                          value="tag"
                          :disabled="Boolean(payload.id)"
                          color="primary"
                        ></v-radio>
                        <template v-if="Boolean(payload.id) && audience.init_type === 'tag'">
                          <div v-if="init_data.length == 0" class="left-align">
                            {{ $t('No tag') }}
                          </div>
                          <ul v-else class="tags">
                            <li
                              v-for="(tag, index) in init_data"
                              :key="'init_data_' + index"
                              class="tag"
                            >
                              <specialtext :text="replaceTags(tag.text)"></specialtext>
                            </li>
                          </ul>
                        </template>
                        <tags
                          v-else-if="audience.init_type === 'tag'"
                          v-model="audience.init_data"
                          style="margin-bottom: 5px"
                          :combobox="true"
                          :tags="init_data"
                          :item-option="getMainItems(init_data)"
                          :custom-option-style="(e) => systemTags.includes(e)"
                          :btn-text="$t('Add tag')"
                          :edit="!payload.id"
                          @tags-changed="addTag($event, 'init_data')"
                          @before-adding-tag="checkTag($event, 'init_data')"
                        ></tags>
                        <span
                          v-if="isValidation && !audience.init_data && audience.init_type === 'tag'"
                          id="stepmessage_audience_init_data"
                          class="error--text"
                        >
                          {{ $t('step_message.validate_tag') }}
                        </span>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-radio
                          :class="[audience.init_type === 'file' ? 'mb-2' : 'mb-4']"
                          :label="$t('step_message.upload_list_file')"
                          value="file"
                          :disabled="Boolean(payload.id)"
                          color="primary"
                        >
                        </v-radio>
                        <input
                          ref="inputFile"
                          type="file"
                          accept=".csv"
                          style="display: none"
                          @change="onUploadFile"
                        />
                        <v-btn
                          v-if="audience.init_type === 'file' && !audience.init_options.file_name"
                          class="mb-4"
                          color="primary"
                          outline
                          small
                          :disabled="Boolean(payload.id)"
                          @click="onClickInputFile()"
                        >
                          <img
                            v-if="!payload.id"
                            src="/static/img/download.svg"
                            width="15px"
                            class="mr-2"
                          />
                          <img
                            v-else
                            src="/static/img/download-disabled.svg"
                            width="15px"
                            class="mr-2"
                          />
                          {{ $t('step_message.import_file') }}
                        </v-btn>
                        <div v-else-if="audience.init_type === 'file'" class="tag-file">
                          <v-icon>description</v-icon>
                          {{ audience.init_options.file_name }}
                          <v-btn
                            color="primary"
                            icon
                            small
                            :disabled="Boolean(payload.id)"
                            @click="clearFile"
                          >
                            <v-icon color="primary">close</v-icon>
                          </v-btn>
                        </div>
                        <span
                          v-if="
                            isValidation && !audience.init_data && audience.init_type === 'file'
                          "
                          id="stepmessage_audience_init_data"
                          class="error--text"
                          >{{ $t('step_message.validate_file') }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <span
                    v-if="isValidation && audience.init_type === ''"
                    id="stepmessage_audience_init_type"
                    class="error--text"
                  >
                    {{ $t('step_message.validate_choose') }}
                  </span>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </div>
        <div class="timeline-item" style="--content: '2'">
          <h4 class="timeline-item--header">{{ $t('step_message.add_delete_user') }}</h4>
          <div class="timeline-content mb-4">
            <v-container class="grid-list-md">
              <v-layout class="w-100" row wrap>
                <v-flex xs12>
                  <h4>{{ $t('step_message.add_audience') }} <span>*</span></h4>
                  <div>{{ $t('step_message.add_users') }}</div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="audience.tag_target_group_add_type" column>
                    <v-radio
                      :class="[audience.tag_target_group_add_type === 'specific' ? 'mb-1' : 'mb-4']"
                      :label="$t('step_message.specify_tags')"
                      value="specific"
                      color="primary"
                    ></v-radio>
                    <div
                      :class="[audience.tag_target_group_add_type === 'specific' ? 'mb-4' : 'mb-0']"
                    >
                      <tags
                        v-if="audience.tag_target_group_add_type === 'specific'"
                        v-model="audience.tag_target_group_add_data"
                        :combobox="true"
                        :tags="tag_target_group_add_data"
                        :item-option="getMainItems(tag_target_group_add_data)"
                        :custom-option-style="(e) => systemTags.includes(e)"
                        :btn-text="$t('Add tag')"
                        style="margin-bottom: 5px"
                        @tags-changed="addTag($event, 'tag_target_group_add_data')"
                        @before-adding-tag="checkTag($event, 'tag_target_group_add_data')"
                      ></tags>
                      <span
                        v-if="!validator.tag_target_group_add_type_dup"
                        id="stepmessage_audience_tag_target_group_add_type"
                        class="error--text"
                      >
                        {{ $t('step_message.validate_tag_dup') }}
                      </span>
                      <span
                        v-else-if="
                          isValidation &&
                          !audience.tag_target_group_add_data &&
                          audience.tag_target_group_add_type === 'specific'
                        "
                        id="stepmessage_audience_tag_target_group_add_data"
                        class="error--text"
                      >
                        {{ $t('step_message.validate_tag') }}
                      </span>
                    </div>
                    <v-radio
                      class="mb-4"
                      value="all"
                      color="primary"
                      :label="$t('step_message.all_tags')"
                    ></v-radio>
                  </v-radio-group>
                  <span
                    v-if="isValidation && audience.tag_target_group_add_type === ''"
                    id="stepmessage_audience_tag_target_group_add_type"
                    class="error--text"
                  >
                    {{ $t('step_message.validate_choose') }}
                  </span>
                </v-flex>
                <v-flex xs12>
                  <div class="divider-seemore">
                    <div class="divider-seemore--content" @click="toggleAddAdvanced()">
                      {{ $t('Advanced') }}
                      <v-icon>
                        {{ !showAddAdvanced ? 'arrow_drop_down' : 'arrow_drop_up' }}
                      </v-icon>
                    </div>
                  </div>
                </v-flex>
                <template v-if="showAddAdvanced">
                  <v-flex xs12>
                    <h4>{{ $t('step_message.manage_user_tag') }}</h4>
                  </v-flex>
                  <v-flex xs12>
                    <div>{{ $t('step_message.add_tag') }}</div>
                  </v-flex>
                  <v-flex xs12>
                    <tags
                      v-model="audience.tag_target_group_add_add_tag"
                      :combobox="true"
                      :tags="tag_target_group_add_add_tag"
                      :item-option="subItems"
                      :btn-text="$t('Add tag')"
                      style="margin-bottom: 5px"
                      @tags-changed="addTag($event, 'tag_target_group_add_add_tag')"
                      @before-adding-tag="checkTag($event, 'tag_target_group_add_add_tag')"
                    ></tags>
                  </v-flex>
                  <v-flex xs12>
                    <div>{{ $t('step_message.delete_tag') }}</div>
                  </v-flex>
                  <v-flex xs12>
                    <tags
                      v-model="audience.tag_target_group_add_remove_tag"
                      :combobox="true"
                      :tags="tag_target_group_add_remove_tag"
                      :item-option="subItems"
                      :btn-text="$t('Add tag')"
                      style="margin-bottom: 5px"
                      @tags-changed="addTag($event, 'tag_target_group_add_remove_tag')"
                      @before-adding-tag="checkTag($event, 'tag_target_group_add_remove_tag')"
                    ></tags>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </div>
          <div class="timeline-content">
            <v-container class="grid-list-md">
              <v-layout class="w-100" row wrap>
                <v-flex xs12>
                  <h4>{{ $t('step_message.delete_audience') }} <span>*</span></h4>
                  <div>{{ $t('step_message.remove_users') }}</div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="audience.tag_target_group_remove_type" column>
                    <v-radio
                      :class="[
                        audience.tag_target_group_remove_type === 'specific' ? 'mb-1' : 'mb-4'
                      ]"
                      :label="$t('step_message.specify_tags')"
                      value="specific"
                      color="primary"
                    ></v-radio>
                    <div
                      :class="[
                        audience.tag_target_group_remove_type === 'specific' ? 'mb-4' : 'mb-1'
                      ]"
                    >
                      <tags
                        v-if="audience.tag_target_group_remove_type === 'specific'"
                        v-model="audience.tag_target_group_remove_data"
                        :combobox="true"
                        :tags="tag_target_group_remove_data"
                        :item-option="getMainItems(tag_target_group_remove_data)"
                        :custom-option-style="(e) => systemTags.includes(e)"
                        :btn-text="$t('Add tag')"
                        style="margin-bottom: 5px"
                        @tags-changed="addTag($event, 'tag_target_group_remove_data')"
                        @before-adding-tag="checkTag($event, 'tag_target_group_remove_data')"
                      ></tags>
                      <span
                        v-if="!validator.tag_target_group_remove_type_dup"
                        id="stepmessage_audience_tag_target_group_remove_dup"
                        class="error--text"
                      >
                        {{ $t('step_message.validate_tag_dup') }}
                      </span>
                      <span
                        v-else-if="
                          isValidation &&
                          !audience.tag_target_group_remove_data &&
                          audience.tag_target_group_remove_type === 'specific'
                        "
                        id="stepmessage_audience_tag_target_group_remove_data"
                        class="error--text"
                      >
                        {{ $t('step_message.validate_tag') }}
                      </span>
                    </div>
                    <v-radio
                      class="mb-4"
                      :label="$t('step_message.all_tags')"
                      value="all"
                      color="primary"
                    ></v-radio>
                    <v-radio
                      class="mb-4"
                      :label="$t('step_message.not_use_tags')"
                      :value="null"
                      color="primary"
                    ></v-radio>
                  </v-radio-group>
                  <span
                    v-if="isValidation && audience.tag_target_group_remove_type === ''"
                    id="stepmessage_audience_tag_target_group_remove_type"
                    class="error--text"
                  >
                    {{ $t('step_message.validate_choose') }}
                  </span>
                </v-flex>
                <v-flex xs12>
                  <div class="divider-seemore">
                    <div class="divider-seemore--content" @click="toggleDeleteAdvanced()">
                      {{ $t('Advanced') }}
                      <v-icon>
                        {{ !showDeleteAdvanced ? 'arrow_drop_down' : 'arrow_drop_up' }}
                      </v-icon>
                    </div>
                  </div>
                </v-flex>
                <template v-if="showDeleteAdvanced">
                  <v-flex xs12>
                    <h4>{{ $t('step_message.manage_user_tag') }}</h4>
                  </v-flex>
                  <v-flex xs12>
                    <div>{{ $t('step_message.add_tag') }}</div>
                  </v-flex>
                  <v-flex xs12>
                    <tags
                      v-model="audience.tag_target_group_remove_add_tag"
                      :combobox="true"
                      :tags="tag_target_group_remove_add_tag"
                      :item-option="subItems"
                      :custom-option-style="(e) => systemTags.includes(e)"
                      :btn-text="$t('Add tag')"
                      style="margin-bottom: 5px"
                      @tags-changed="addTag($event, 'tag_target_group_remove_add_tag')"
                      @before-adding-tag="checkTag($event, 'tag_target_group_remove_add_tag')"
                    ></tags>
                  </v-flex>
                  <v-flex xs12>
                    <div>{{ $t('step_message.delete_tag') }}</div>
                  </v-flex>
                  <v-flex xs12>
                    <tags
                      v-model="audience.tag_target_group_remove_remove_tag"
                      :combobox="true"
                      :tags="tag_target_group_remove_remove_tag"
                      :item-option="subItems"
                      :custom-option-style="(e) => systemTags.includes(e)"
                      :btn-text="$t('Add tag')"
                      style="margin-bottom: 5px"
                      @tags-changed="addTag($event, 'tag_target_group_remove_remove_tag')"
                      @before-adding-tag="checkTag($event, 'tag_target_group_remove_remove_tag')"
                    ></tags>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </div>
        </div>
        <div class="timeline-item" style="--content: '3'">
          <h4 class="timeline-item--header">{{ $t('step_message.target') }}</h4>
          <div class="timeline-content transparent">
            <v-container class="grid-list-md pa-0">
              <v-layout class="w-100 mb-1" row wrap>
                <v-flex xs12 class="mb-1">
                  <v-checkbox
                    v-model="audience.is_allowed_broadcast"
                    class="mt-0"
                    color="primary"
                    hide-details
                  >
                    <template #label>
                      <div>{{ $t('step_message.create_for_broadcast') }}</div>
                    </template>
                  </v-checkbox>
                </v-flex>
                <v-flex class="step-message-checkbox mb-1" xs12>
                  <v-checkbox
                    v-model="audience.is_enabled_auto_upload_line"
                    class="d-inline-block"
                    :disabled="!selectedBot.line_modular_botid && !selectedBot.line_access_token"
                    color="primary"
                    hide-details
                  >
                    <template #label>
                      <div>
                        {{ $t('step_message.upload_to_line_oa') }} ({{
                          $t('step_message.audience_for_broadcast')
                        }})
                        <span class="primary--text">{{ $t('step_message.daily') }}</span>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-premium-lock2
                    v-if="!selectedBot.line_modular_botid && !selectedBot.line_access_token"
                    :value="true"
                    :inline="true"
                    :small="true"
                    type="advanced"
                    class="ml-2 mb-4"
                    text="step_message.setting_line_oa_for_use"
                    :custom-route="{
                      name: 'setting',
                      path: '/billing',
                      query: {
                        tab: 'socialConnect'
                      }
                    }"
                  ></v-premium-lock2>
                </v-flex>
                <v-flex class="step-message-checkbox mb-1" xs12>
                  <v-checkbox
                    v-model="audience.is_enabled_auto_upload_line_step_message"
                    class="d-inline-block"
                    :disabled="!selectedBot.line_modular_botid && !selectedBot.line_access_token"
                    color="primary"
                    hide-details
                  >
                    <template #label>
                      <div>
                        {{ $t('step_message.upload_to_line_oa') }} ({{
                          $t('step_message.audience_for_step_message')
                        }})
                        <span class="primary--text">{{ $t('step_message.daily') }}</span>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-premium-lock2
                    v-if="!selectedBot.line_modular_botid && !selectedBot.line_access_token"
                    :value="true"
                    :inline="true"
                    :small="true"
                    type="advanced"
                    class="ml-2 mb-4"
                    text="step_message.setting_line_oa_for_use"
                    :custom-route="{
                      name: 'setting',
                      path: '/billing',
                      query: {
                        tab: 'socialConnect'
                      }
                    }"
                  ></v-premium-lock2>
                </v-flex>
                <v-flex class="step-message-checkbox mb-1" xs12>
                  <v-checkbox
                    v-model="audience.is_enabled_auto_upload_facebook"
                    class="d-inline-block"
                    color="primary"
                    hide-details
                  >
                    <template #label>
                      <div>
                        {{ $t('step_message.upload_to_fb') }}
                        <span class="primary--text">{{ $t('step_message.daily_fb') }}</span>
                      </div>
                    </template>
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </div>
      </div>
    </v-flex>
    <v-flex xs12 class="text-xs-center">
      <v-btn color="primary" depressed outline @click="cancel">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" depressed :loading="isLoading" @click="submit">{{ $t('Save') }}</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Tags from '@/components/elements/Tags.vue'
import specialtext from '@/components/elements/specialtext.vue'
import {
  defaultCompleteTag,
  defaultMoreTag,
  checkIsTagVerifySlipComplete,
  checkIsTagVerifySlipMore,
  checkIsTagVerifySlip,
  getTagWithDefaultVerifySlipTag,
  getRealTag,
  replaceTags
} from '@/utils/tags'
import audienceApi from '@/api/audience'

const systemTags = {
  // ประกาศครั้งแรก: '{first_announcement_message}',
  'ตรวจสลิป 1 ครั้ง': '{{slip_completed_1}}',
  'ตรวจสลิปมากกว่า 1 ครั้ง': '{{slip_completed_more_than_1}}'
}

export default {
  components: { Tags, specialtext },
  props: {
    payload: {
      type: Object,
      default: () => ({
        name: '',
        init_type: '',
        init_data: '',
        init_options: {
          file_name: '',
          total_completed_verify_slip: null,
          total_completed_verify_slip_more_than: null
        },
        tag_target_group_add_type: '',
        tag_target_group_add_data: '',
        tag_target_group_add_add_tag: '',
        tag_target_group_add_remove_tag: '',
        tag_target_group_remove_type: '',
        tag_target_group_remove_data: '',
        tag_target_group_remove_add_tag: '',
        tag_target_group_remove_remove_tag: '',
        is_allowed_broadcast: false,
        is_enabled_auto_upload_line: false,
        is_enabled_auto_upload_line_step_message: false,
        is_enabled_auto_upload_facebook: false
      })
    }
  },
  data: () => ({
    isRendering: false,
    isLoading: false,
    mainItems: [],
    subItems: [],
    showAddAdvanced: false,
    showDeleteAdvanced: false,
    isValidation: false,
    validator: {
      name: true,
      init_type: true,
      init_data: true,
      tag_target_group_add_type: true,
      tag_target_group_add_data: true,
      tag_target_group_remove_type: true,
      tag_target_group_remove_data: true,
      tag_target_group_add_type_dup: true,
      tag_target_group_remove_type_dup: true
    },
    systemTags: ['ตรวจสลิป 1 ครั้ง', 'ตรวจสลิปมากกว่า 1 ครั้ง']
  }),
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    audience: {
      get() {
        return this.payload
      },
      set(value) {
        this.$emit('update:payload', value)
      }
    },
    init_data: {
      get() {
        if (this.audience.init_data) {
          let tags = []
          tags = this.audience.init_data.split(',')
          const result = []
          if (tags) {
            for (let i = 0; i < tags.length; i++) {
              const text = tags[i]
              result.push({ text })
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const result = []
        if (value) {
          for (let i = 0; i < value.length; i++) {
            const tag = value[i]
            result.push(tag.text)
          }
        }
        this.audience.init_data = result.join(',')
      }
    },
    tag_target_group_add_data: {
      get() {
        if (this.audience.tag_target_group_add_data) {
          let tags = []
          tags = this.audience.tag_target_group_add_data.split(',')
          const result = []
          if (tags) {
            for (let i = 0; i < tags.length; i++) {
              const text = tags[i]
              result.push({ text })
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const result = []
        if (value) {
          for (let i = 0; i < value.length; i++) {
            const tag = value[i]
            result.push(tag.text)
          }
        }
        this.audience.tag_target_group_add_data = result.join(',')
      }
    },
    tag_target_group_add_add_tag: {
      get() {
        if (this.audience.tag_target_group_add_add_tag) {
          let tags = []
          tags = this.audience.tag_target_group_add_add_tag.split(',')
          const result = []
          if (tags) {
            for (let i = 0; i < tags.length; i++) {
              const text = tags[i]
              result.push({ text })
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const result = []
        if (value) {
          for (let i = 0; i < value.length; i++) {
            const tag = value[i]
            result.push(tag.text)
          }
        }
        this.audience.tag_target_group_add_add_tag = result.join(',')
      }
    },
    tag_target_group_add_remove_tag: {
      get() {
        if (this.audience.tag_target_group_add_remove_tag) {
          let tags = []
          tags = this.audience.tag_target_group_add_remove_tag.split(',')
          const result = []
          if (tags) {
            for (let i = 0; i < tags.length; i++) {
              const text = tags[i]
              result.push({ text })
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const result = []
        if (value) {
          for (let i = 0; i < value.length; i++) {
            const tag = value[i]
            result.push(tag.text)
          }
        }
        this.audience.tag_target_group_add_remove_tag = result.join(',')
      }
    },
    tag_target_group_remove_data: {
      get() {
        if (this.audience.tag_target_group_remove_data) {
          let tags = []
          tags = this.audience.tag_target_group_remove_data.split(',')
          const result = []
          if (tags) {
            for (let i = 0; i < tags.length; i++) {
              const text = tags[i]
              result.push({ text })
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const result = []
        if (value) {
          for (let i = 0; i < value.length; i++) {
            const tag = value[i]
            result.push(tag.text)
          }
        }
        this.audience.tag_target_group_remove_data = result.join(',')
      }
    },
    tag_target_group_remove_add_tag: {
      get() {
        if (this.audience.tag_target_group_remove_add_tag) {
          let tags = []
          tags = this.audience.tag_target_group_remove_add_tag.split(',')
          const result = []
          if (tags) {
            for (let i = 0; i < tags.length; i++) {
              const text = tags[i]
              result.push({ text })
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const result = []
        if (value) {
          for (let i = 0; i < value.length; i++) {
            const tag = value[i]
            result.push(tag.text)
          }
        }
        this.audience.tag_target_group_remove_add_tag = result.join(',')
      }
    },
    tag_target_group_remove_remove_tag: {
      get() {
        if (this.audience.tag_target_group_remove_remove_tag) {
          let tags = []
          tags = this.audience.tag_target_group_remove_remove_tag.split(',')
          const result = []
          if (tags) {
            for (let i = 0; i < tags.length; i++) {
              const text = tags[i]
              result.push({ text })
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const result = []
        if (value) {
          for (let i = 0; i < value.length; i++) {
            const tag = value[i]
            result.push(tag.text)
          }
        }
        this.audience.tag_target_group_remove_remove_tag = result.join(',')
      }
    },
    mainItemsValue: {
      get() {
        let tags = this.mainItems.join(',')
        if (!checkIsTagVerifySlip(tags)) {
          let allTags = getTagWithDefaultVerifySlipTag(tags)
          return allTags.split(',')
        } else {
          return tags.split(',')
        }
      },
      set(value) {
        this.mainItems = value
      }
    }
  },
  async created() {
    this.isRendering = true
    await this.$store.dispatch('loadTags')
    // this.mainItems = ['ตรวจสลิป 1 ครั้ง', 'ตรวจสลิปมากกว่า 1 ครั้ง']
    this.subItems = []
    await this.loadTag()
    await new Promise((resolve) => setTimeout(resolve, 500))
    this.isRendering = false
  },
  methods: {
    replaceTags,
    async loadTag() {
      const userTags = this.$store.state.userTags
        .map((item) => item.name)
        .filter((name) => !this.mainItems.includes(name))
      this.mainItems = [...this.mainItems, ...userTags]
      this.subItems = [...userTags]
    },
    onClickBack() {
      this.showAddAdvanced = false
      this.showDeleteAdvanced = false
      this.isValidation = false
      this.$emit('back', true)
    },
    addTag(newTag, type) {
      let itemNewTags = newTag.map((item) => {
        item.text = systemTags[item.text] || item.text
        return item
      })

      itemNewTags = itemNewTags.filter(
        (item) => !this[type].map((type) => type.text).includes(item.text)
      )
      const defaultTypes = [...new Set([...this[type]].map(JSON.stringify))].map(JSON.parse)
      this[type] = [...defaultTypes, ...itemNewTags]
    },
    async checkTag(obj, type) {
      let tags = []
      if (type === 'tag_target_group_add_data') {
        tags = this[`tag_target_group_remove_data`].map(({ text }) => text) || []
      } else if (type === 'tag_target_group_remove_data') {
        tags = this[`tag_target_group_add_data`].map(({ text }) => text) || []
      }

      const text = systemTags[obj.tag.text] || obj.tag.text

      if (type === 'tag_target_group_add_data' && tags.includes(text)) {
        this.validator.tag_target_group_add_type_dup = false
        await new Promise((resolve) => setTimeout(resolve, 3000))
        this.validator.tag_target_group_add_type_dup = true
      } else if (type === 'tag_target_group_remove_data' && tags.includes(text)) {
        this.validator.tag_target_group_remove_type_dup = false
        await new Promise((resolve) => setTimeout(resolve, 3000))
        this.validator.tag_target_group_remove_type_dup = true
      } else if (obj.tag.text.length > 9999) {
        console.log('overmaxlength')
        // this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        if (type === 'tag_target_group_add_data') {
          this.validator.tag_target_group_add_type_dup = false
          await new Promise((resolve) => setTimeout(resolve, 3000))
          this.validator.tag_target_group_add_type_dup = true
        } else if (type === 'tag_target_group_remove_data') {
          this.validator.tag_target_group_remove_type_dup = false
          await new Promise((resolve) => setTimeout(resolve, 3000))
          this.validator.tag_target_group_remove_type_dup = true
        }
        console.log('duplicate')
        // this.errorFilterTag.push('duplicate')
        obj.error()
      } else {
        if (!this.mainItems.includes(obj.tag.text)) {
          this.mainItems.push(obj.tag.text)
        }

        if (!this.subItems.includes(obj.tag.text)) {
          this.subItems.push(obj.tag.text)
        }
        obj.addTag()
      }
    },
    async submit() {
      try {
        this.isValidation = true
        await new Promise((resolve) => setTimeout(resolve, 300))
        const transformData = (arr) => {
          return arr ? arr.split(',') : []
        }

        const initData = getRealTag(this.audience.init_data)
        const initOption = {}

        if (initData && initData.complete) {
          Object.assign(initOption, { total_completed_verify_slip: Number(initData.complete) })
        } else {
          Object.assign(initOption, { total_completed_verify_slip: null })
        }

        if (initData && initData.moreThan) {
          Object.assign(initOption, {
            total_completed_verify_slip_more_than: Number(initData.moreThan)
          })
        } else {
          Object.assign(initOption, { total_completed_verify_slip_more_than: null })
        }

        const addData = getRealTag(this.audience.tag_target_group_add_data)
        const addOption = {}

        if (addData && addData.complete) {
          Object.assign(addOption, {
            tag_target_group_add_total_completed_verify_slip: Number(addData.complete)
          })
        } else {
          Object.assign(addOption, { tag_target_group_add_total_completed_verify_slip: null })
        }

        if (addData && addData.moreThan) {
          Object.assign(addOption, {
            tag_target_group_add_total_completed_verify_slip_more_than: Number(addData.moreThan)
          })
        } else {
          Object.assign(addOption, {
            tag_target_group_add_total_completed_verify_slip_more_than: null
          })
        }

        const removeData = getRealTag(this.audience.tag_target_group_remove_data)
        const removeOption = {}

        if (removeData && removeData.complete) {
          Object.assign(removeOption, {
            tag_target_group_remove_total_completed_verify_slip: Number(removeData.complete)
          })
        } else {
          Object.assign(removeOption, { tag_target_group_remove_total_completed_verify_slip: null })
        }

        if (removeData && removeData.moreThan) {
          Object.assign(removeOption, {
            tag_target_group_remove_total_completed_verify_slip_more_than: Number(
              removeData.moreThan
            )
          })
        } else {
          Object.assign(removeOption, {
            tag_target_group_remove_total_completed_verify_slip_more_than: null
          })
        }

        const payload = {
          name: this.audience.name,
          init_type: this.audience.init_type,
          init_data: initData ? initData.items : transformData(this.audience.init_data),
          init_options: {
            file_name: this.audience.init_options.file_name,
            ...initOption
          },
          tag_target_group_add_type: this.audience.tag_target_group_add_type,
          tag_target_group_add_data: addData
            ? addData.items
            : transformData(this.audience.tag_target_group_add_data),
          ...addOption,
          tag_target_group_add_add_tag: transformData(this.audience.tag_target_group_add_add_tag),
          tag_target_group_add_remove_tag: transformData(
            this.audience.tag_target_group_add_remove_tag
          ),
          tag_target_group_remove_type: this.audience.tag_target_group_remove_type,
          tag_target_group_remove_data: removeData
            ? removeData.items
            : transformData(this.audience.tag_target_group_remove_data),
          ...removeOption,
          tag_target_group_remove_add_tag: transformData(
            this.audience.tag_target_group_remove_add_tag
          ),
          tag_target_group_remove_remove_tag: transformData(
            this.audience.tag_target_group_remove_remove_tag
          ),
          is_allowed_broadcast: this.audience.is_allowed_broadcast,
          is_enabled_auto_upload_line: this.audience.is_enabled_auto_upload_line,
          is_enabled_auto_upload_line_step_message:
            this.audience.is_enabled_auto_upload_line_step_message,
          is_enabled_auto_upload_facebook: this.audience.is_enabled_auto_upload_facebook
        }

        Object.assign(this.validator, {
          name: !!this.audience.name,
          init_type: this.audience.init_type !== '',
          init_data:
            (this.audience.init_type !== 'tag' && this.audience.init_type !== 'file') ||
            !!this.audience.init_data,
          tag_target_group_add_type: this.audience.tag_target_group_add_type !== '',
          tag_target_group_add_data:
            this.audience.tag_target_group_add_type !== 'specific' ||
            !!this.audience.tag_target_group_add_data,
          tag_target_group_remove_type: this.audience.tag_target_group_remove_type !== '',
          tag_target_group_remove_data:
            this.audience.tag_target_group_remove_type !== 'specific' ||
            !!this.audience.tag_target_group_remove_data
        })

        if (this.payload.id) {
          this.validator.init_type = true
          this.validator.init_data = true
        }

        const isValid = Object.values(this.validator).every((value) => !!value)

        for (const [key, value] of Object.entries(this.validator)) {
          if (!value) {
            const element = document.getElementById(`stepmessage_audience_${key}`)
            if (element) {
              const rect = element.getBoundingClientRect()
              const top = rect.y || rect.top
              window.scrollTo({ top: top + window.pageYOffset - 164, behavior: 'smooth' })
            }
            break
          }
        }

        await new Promise((resolve) => setTimeout(resolve, 500))

        if (!isValid) {
          if (!this.validator.name) {
            await this.$swal.fire({
              type: 'warning',
              title: this.$t('step_message.validate_name')
            })
          } else if (!this.validator.init_data && this.audience.init_type === 'file') {
            await this.$swal.fire({
              type: 'warning',
              title: this.$t('step_message.validate_file')
            })
          } else if (
            !this.validator.init_data ||
            !this.validator.tag_target_group_add_data ||
            !this.validator.tag_target_group_remove_data
          ) {
            await this.$swal.fire({
              type: 'warning',
              title: this.$t('step_message.validate_tag')
            })
          }

          return
        }

        if (this.isLoading) return
        this.isLoading = true

        if (!this.payload.id) {
          const result = await this.create(payload)
          this.isLoading = false
          if (result) {
            this.reset()
            this.$emit('create:success', true)
          }
        } else {
          const result = await this.edit(payload)
          this.isLoading = false
          if (result) {
            this.reset()
            this.$emit('edit:success', true)
          }
        }
      } catch (error) {
        console.log({ error })
      }
    },
    cancel() {
      this.reset()
      this.onClickBack()
    },
    reset() {
      this.isValidation = false

      this.audience.id = null
      this.audience.name = ''
      this.audience.init_type = null
      this.audience.init_data = ''
      this.audience.init_options.file_name = ''
      this.audience.tag_target_group_add_type = 'specific'
      this.audience.tag_target_group_add_data = ''
      this.audience.tag_target_group_add_add_tag = ''
      this.audience.tag_target_group_add_remove_tag = ''
      this.audience.tag_target_group_remove_type = 'specific'
      this.audience.tag_target_group_remove_data = ''
      this.audience.tag_target_group_remove_add_tag = ''
      this.audience.tag_target_group_remove_remove_tag = ''
      this.audience.is_allowed_broadcast = true
      this.audience.is_enabled_auto_upload_line = false
      this.audience.is_enabled_auto_upload_line_step_message = false
      this.audience.is_enabled_auto_upload_facebook = false

      this.isLoading = false
      this.showAddAdvanced = false
      this.showDeleteAdvanced = false
    },
    async create(payload) {
      try {
        const res = await audienceApi.postAudience({
          page_id: this.selectedBot.pageid,
          ...payload
        })
        if (res.status === 200) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('step_message.create_audience_success')
          })
          return true
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          await this.$swal.fire({
            type: 'error',
            title: this.$t('step_message.create_audience_failed'),
            text: JSON.stringify(error.response.data.message)
          })
          return false
        }
        await this.$swal.fire({
          type: 'error',
          title: this.$t('Unsuccessful')
        })
        return false
      }
    },
    async edit(payload) {
      try {
        const res = await audienceApi.patchAudience({
          page_id: this.selectedBot.pageid,
          audience_id: this.payload.id,
          ...payload
        })
        if (res.status === 200) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('step_message.edit_audience_success')
          })
          return true
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          await this.$swal.fire({
            type: 'error',
            title: this.$t('step_message.edit_audience_failed'),
            text: JSON.stringify(error.response.data.message)
          })
          return false
        }
        await this.$swal.fire({
          type: 'error',
          title: this.$t('Unsuccessful')
        })
        return false
      }
    },
    toggleAddAdvanced() {
      this.showAddAdvanced = !this.showAddAdvanced
    },
    toggleDeleteAdvanced() {
      this.showDeleteAdvanced = !this.showDeleteAdvanced
    },
    onChangeInitType() {
      this.init_data = []
    },
    onClickInputFile() {
      this.$refs.inputFile.click()
    },
    async onUploadFile(event) {
      const { files } = event.target
      const [file] = files
      if (!file) return
      if (file.type !== 'text/csv') {
        await this.$swal.fire({
          type: 'warning',
          title: ''
        })
      } else if (file) {
        this.readFile(file)
        this.audience.init_options.file_name = file.name
        this.init_data = await this.readFile(file)
        this.$refs.inputFile.value = ''
      }
    },
    async readFile(file) {
      const keySelected = 'pageuid'

      return await new Promise((resolve) => {
        const reader = new FileReader()

        reader.onload = function (e) {
          const csvData = e.target.result
          const rows = csvData.split('\n')
          const header = rows[0].split(',')
          rows.shift()

          const jsonArray = []

          rows.forEach((row) => {
            const values = row.split(',')
            const jsonObject = {}

            header.forEach((key, index) => {
              jsonObject[key] = values[index]
            })

            jsonArray.push(jsonObject)
          })
          resolve(jsonArray.map((item) => ({ text: item[keySelected] })))
        }
        reader.readAsText(file)
      })
    },
    clearFile() {
      this.init_data = []
      this.audience.init_options.file_name = ''
    },
    getMainItems(e) {
      const itemValue = e ? [...e].map((item) => item.text) : []
      const items = getTagWithDefaultVerifySlipTag([...this.mainItems])
      let tags = []

      const foundTagCompleted = itemValue.some((f) => checkIsTagVerifySlipComplete(f))

      const foundTagMore = itemValue.some((f) => checkIsTagVerifySlipMore(f))

      for (let i = 0; i < items.length; i++) {
        const tag = items[i]

        if (tag === defaultCompleteTag && !foundTagCompleted) {
          tags.push(tag)
        } else if (tag === defaultMoreTag && !foundTagMore) {
          tags.push(tag)
        } else if (
          tag !== defaultCompleteTag &&
          tag !== defaultMoreTag &&
          !checkIsTagVerifySlipComplete(tag) &&
          !checkIsTagVerifySlipMore(tag)
        ) {
          tags.push(tag)
        }
      }

      return tags
    }
  }
}
</script>

<style lang="scss" scoped>
.timeline {
  position: relative;
  margin: 20px auto;
}

.timeline-item {
  position: relative;
  margin-bottom: 20px;
}

.timeline-item--header {
  font-size: 16px;
  color: inherit;
  font-weight: 500;
  margin-bottom: 16px;
  margin-left: -16px;
}

.timeline-content {
  background-color: #fff;
  border-radius: 20px 20px 20px 0px !important;
}

.timeline-content.transparent {
  background-color: transparent;
}

.timeline-item:not(:last-child)::before {
  content: '';
  position: absolute;
  top: 34px;
  left: -34px;
  width: 1px;
  height: calc(100% - 20px);
  background-color: #d9d9d9;
  // transform: translateX(-50%);
}

.timeline-item:after {
  content: var(--content);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: -48px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: #fff;
  font-size: 16px;
}

.divider-seemore {
  position: relative;
  display: flex;
  width: 100%;
  flex: 1 1 0;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    top: 50%;
    width: 100%;
    height: 1px;
    background: #d7d7d7;
  }

  .divider-seemore--content {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 2px;
    padding: 4px 8px;
    min-width: 100px;
    border: 1px solid#D7D7D7;
    border-radius: 999px;
    -o-border-radius: 999px;
    -ms-border-radius: 999px;
    text-align: center;
    background: #fff;
    cursor: pointer;
  }
}

.tag-file {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 2px;
  background-color: rgba($color: #d9d9d9, $alpha: 0.2);
  width: fit-content;
  padding: 2px 4px;

  .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
    border-radius: 50% !important;
    -o-border-radius: 50% !important;
    -ms-border-radius: 50% !important;
    background-color: rgba(237, 30, 121, 0.3) !important;
  }

  .theme--light.v-btn.v-btn--disabled {
    background-color: rgba(0, 0, 0, 0.15) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/stepmessage/AudienceForm.vue